import { render, staticRenderFns } from "./HeavyStockList.vue?vue&type=template&id=c95700ae&scoped=true&"
import script from "./HeavyStockList.vue?vue&type=script&lang=js&"
export * from "./HeavyStockList.vue?vue&type=script&lang=js&"
import style0 from "./HeavyStockList.vue?vue&type=style&index=0&id=c95700ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95700ae",
  null
  
)

export default component.exports